module.exports = __webpack_public_path__ + "img/title-zh.0bd8b337.png";